import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-semibold mb-3">
              最新动态
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              每日大赛实时快讯
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-3">
              第一时间了解新PK上线、功能更新和社区动态
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300 hidden sm:block"></div>

            <div className="space-y-1">
              {updatesData.map((item) => (
                <div key={item.id} className="flex gap-4 py-3 group cursor-pointer">
                  <div className="hidden sm:flex flex-col items-center flex-shrink-0 pt-1">
                    <div className="w-[10px] h-[10px] rounded-full bg-accent-500 group-hover:bg-accent-600 transition-colors relative z-10"></div>
                  </div>
                  <div className="flex-1 min-w-0 bg-background-50 rounded-xl p-4 border border-background-200/70 group-hover:border-accent-200 transition-all duration-300">
                    <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 mb-2">
                      <span className="text-xs text-foreground-500 font-medium whitespace-nowrap">{item.date}</span>
                      <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-semibold w-fit whitespace-nowrap">
                        {item.tag}
                      </span>
                    </div>
                    <p className="text-sm md:text-base text-foreground-800 font-medium leading-relaxed">
                      {item.title}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}